import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';

import { Box, Header, Text } from '@fhs-legacy/universal-components';
import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Dialog from 'components/dialog';
import { useCRMEventsContext } from 'state/crm-events';
import { ErrorDialogViewComponentNames } from 'state/crm-events/constants';

interface IConfirmRedemptionDialogProps {
  showDialog: boolean;
  dismiss: () => void;
}

const ErrorInStoreRedemptionDialog = ({ showDialog, dismiss }: IConfirmRedemptionDialogProps) => {
  const { formatMessage } = useIntl();
  const { logErrorDialogView } = useCRMEventsContext();

  useEffect(() => {
    logErrorDialogView(
      ErrorDialogViewComponentNames.REDEMPTION_ERROR_MODAL,
      'Error redeem in restaurant Dialog'
    );
  });

  return (
    <Dialog
      showDialog={showDialog}
      ariaLabel={formatMessage({ id: 'inStoreRedemptionErrorHeader' })}
      headingComponent={
        <Header variant="headerOne">{formatMessage({ id: 'inStoreRedemptionErrorHeader' })}</Header>
      }
      bodyComponent={
        <Text variant="copyThree">{formatMessage({ id: 'inStoreRedemptionErrorBody' })}</Text>
      }
      actions={
        <Box width="full" marginTop="$4">
          <ActionButton
            marginTop="$2"
            width="full"
            variant={ActionButtonVariants.PRIMARY}
            onPress={dismiss}
          >
            {formatMessage({ id: 'okay' })}
          </ActionButton>
        </Box>
      }
      modalAppearanceEventMessage="Error redeem in restaurant Dialog"
      onDismiss={dismiss}
    />
  );
};

export default ErrorInStoreRedemptionDialog;
